/**
 * State Isolation Helper for preventing shared component state conflicts
 *
 * This utility helps isolate state between ManualRequestForm and VorgangeDetailsDialog
 * when they share the same subcomponents (KennzeichenRequestForm, HalterRequestForm, etc.)
 */

// Helpers
import {
  antragDefaultForm,
  fahrzeugDefaultForm,
  kennzeichenDefaultForm,
  halterDefaultForm,
  vollmachtDefaultForm,
} from "./vorgange";

// Utility to create deep copies of form default objects to prevent reference sharing
export const createIsolatedFormDefaults = (context = "DEFAULT") => {
  return {
    antragRequestFormData: {
      ...JSON.parse(JSON.stringify(antragDefaultForm)),
      _context: context,
      _timestamp: Date.now(),
    },
    fahrzeugRequestFormData: {
      ...JSON.parse(JSON.stringify(fahrzeugDefaultForm)),
      _context: context,
      _timestamp: Date.now(),
    },
    kennzeichenRequestFormData: {
      ...JSON.parse(JSON.stringify(kennzeichenDefaultForm)),
      _context: context,
      _timestamp: Date.now(),
    },
    halterRequestFormData: {
      ...JSON.parse(JSON.stringify(halterDefaultForm)),
      _context: context,
      _timestamp: Date.now(),
    },
    vollmachtRequestFormData: {
      ...JSON.parse(JSON.stringify(vollmachtDefaultForm)),
      _context: context,
      _timestamp: Date.now(),
    },
  };
};

// State isolation constants
export const COMPONENT_CONTEXTS = {
  MANUAL_REQUEST: "MANUAL_REQUEST_FORM",
  VORGANGE_DETAILS: "VORGANGE_DETAILS_DIALOG",
  DEFAULT: "DEFAULT",
};

// Utility to clean up isolated state
export const cleanupIsolatedState = (context) => {
  const cleanDefaults = createIsolatedFormDefaults(context);

  // Reset all form data to defaults
  return {
    ...cleanDefaults,
    globalMessages: [],
    licensePlateF: "",
    licensePlateM: "",
    licensePlateL: "",
    operationIdsOptions: [],
    halterFormOperationIds: [],
    isStateIsolated: false,
  };
};
